import React, {Component} from 'react';
import ProductItem from './ProductItem';

class TapTheCap extends Component {
    constructor(props) {
        super(props);
        this.videoRef = React.createRef();
        this.modalBodyRef = React.createRef();
        this.state = {
            isPlaying: false,
            showModal: false,
        };
    }

    componentDidUpdate(_, prevState) {
        if (this.state.showModal && !prevState.showModal && this.modalBodyRef.current) {
            this.modalBodyRef.current.focus();
        }

        if (this.state.showModal !== prevState.showModal) {
            document.body.style.overflow = this.state.showModal ? 'hidden' : '';
        }
    }

    componentWillUnmount() {
        document.body.style.overflow = '';
    }

    getProducts() {
        return (Array.isArray(this.props.products) ? this.props.products : [])
            .filter((product) => product && (product.display_image || product.product_image || product.image_path))
            .slice(0, 4);
    }

    handlePlay = async () => {
        const video = this.videoRef.current;
        if (!video) {
            return;
        }

        this.setState({isPlaying: true, showModal: false});

        try {
            if (video.ended || video.currentTime >= (video.duration || 0)) {
                video.currentTime = 0;
            }

            await video.play();
        } catch (error) {
            // Ignore playback blocking errors; the click intent is already captured.
            this.setState({isPlaying: false});
        }
    };

    handleEnded = () => {
        this.setState({isPlaying: false, showModal: true});
    };

    closeModal = () => {
        const video = this.videoRef.current;
        if (video) {
            video.pause();
            video.currentTime = 0;
        }

        this.setState({showModal: false});
    };

    restartVideo = async () => {
        const video = this.videoRef.current;
        if (!video) {
            return;
        }

        video.currentTime = 0;
        await this.handlePlay();
    };

    render() {
        const products = this.getProducts();
        const {showModal, isPlaying} = this.state;

        if (products.length === 0) {
            return null;
        }

        return (
            <section className="container" aria-label="Tap the Cap">
                <div className="ps-tap-the-cap__videoShell">
                    <video
                        ref={this.videoRef}
                        className="ps-tap-the-cap__video"
                        src="/assets/img/tap-the-bull.mp4"
                        muted
                        playsInline
                        preload="metadata"
                        onEnded={this.handleEnded}
                    />

                    {!isPlaying ? (
                        <button
                            type="button"
                            className="ps-tap-the-cap__playOverlay"
                            onClick={this.handlePlay}
                            aria-label="Get Your Oil"
                        >
                            Get Your Oil
                        </button>
                    ) : null}
                </div>

                {showModal ? (
                    <div
                        className="ps-tap-the-cap__modal"
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="tap-the-cap-modal-title"
                    >
                        <button
                            type="button"
                            className="ps-tap-the-cap__backdrop"
                            onClick={this.closeModal}
                            aria-label="Close modal"
                        />
                        <div className="ps-tap-the-cap__dialog" ref={this.modalBodyRef} tabIndex="-1">
                            <div className="ps-tap-the-cap__dialogHeader">
                                <div>
                                    <p className="ps-tap-the-cap__eyebrow">Tap the Bull</p>
                                    <h3 className="ps-tap-the-cap__title" id="tap-the-cap-modal-title">
                                        Explore more natural picks
                                    </h3>
                                </div>
                                <button type="button" className="ps-tap-the-cap__close" onClick={this.closeModal} aria-label="Close">
                                    ×
                                </button>
                            </div>

                            <div className="ps-tap-the-cap__products">
                                {products.map((product, index) => (
                                    <ProductItem product_details={product} key={`${product.variation_id || product.product_id || index}-${index}`} />
                                ))}
                            </div>

                            <div className="ps-tap-the-cap__actions">
                                <button type="button" className="ps-tap-the-cap__button ps-tap-the-cap__button--secondary" onClick={this.closeModal}>
                                    Close
                                </button>
                                <button type="button" className="ps-tap-the-cap__button" onClick={this.restartVideo}>
                                    Replay Video
                                </button>
                            </div>
                        </div>
                    </div>
                ) : null}
            </section>
        );
    }
}

export default TapTheCap;
